
import $ from 'jquery';

export default class ScrollSpy {

  constructor(options) {
    if (!options.list) return null;
    this.list = options.list;
    this.anchorLinks = this.list.querySelectorAll('a[href]');
    this.anchorTargets = this.getAnchorTargets();
    this.subnavHeight = (document.querySelector('.c-subnav')) ? document.querySelector('.c-subnav').clientHeight : 0;
    this.offset = 50;

    // console.dir(this);

    this.listen();
  }

  listen() {
    window.addEventListener('scroll', () => {
      for(let i = 0; i < this.anchorTargets.length; i++) {
        if (window.pageYOffset + this.subnavHeight + this.offset > this.anchorTargets[i].offsetTop) {
          let anchorLink = this.list.querySelector(`a[href*='#${this.anchorTargets[i].id}']`);
          this.addClass(anchorLink);
        }
      }
    });

    this.list.addEventListener('click', e => {
      for(let i = 0; i < this.anchorLinks.length; i++) {
        if (e.target === this.anchorLinks[i]) {
          this.scrollTo(document.getElementById(this.getHash(e.target.href)));
        }
      }
    });
  }

  scrollTo(selector) {
    let target = selector;

    if (target) {
      $('html, body').animate({
          scrollTop: target.offsetTop - this.subnavHeight
        }, 200
      );
    }
  }

  addClass(anchorLink) {
    for(let i = 0; i < this.anchorLinks.length; i++) {
      $(this.anchorLinks[i]).parent().removeClass('active');
    }
    $(anchorLink).parent().addClass('active');
  }

  getAnchorTargets() {
    let targets = [];
    for(let i = 0; i < this.anchorLinks.length; i++) {
      const anchorText = this.getHash(this.anchorLinks[i].href);
      targets.push(document.getElementById(anchorText));
    }
    return targets;
  }

  getHash(href) {
    return href.substring(href.indexOf('#') + 1);
  }
}
